class OpInvoiceList extends HTMLElement {
  constructor() {
    super();
    this.retailerId = this.dataset.retailerId;
    this.pageFromUrl = 1;
    if (new URL(window.location.href).searchParams.get('page')) {
      this.pageFromUrl = new URL(window.location.href).searchParams.get('page');
    }
    this.invoicesEndpoint = `/apps/ax/order-portal/retailers/${this.retailerId}/invoices?pageNo=${this.pageFromUrl}`;
    this.fetchInvoices();
  }

  async fetchInvoices() {
    this.classList.add('op-loading');
    const response = await fetch(this.invoicesEndpoint);
    const data = await response.json();
    this.invoices = data.invoices;
    this.totalPages = data.totalPages;
    this.currentPage = data.pageNo;
    this.classList.remove('op-loading');
    if (this.invoices.length) {
      this.renderInvoices();
      this.renderPagination();
    } else {
      this.querySelector('.op-table').classList.add('hidden');
    }
  }

  renderPagination() {
    const pagination = this.querySelector('.op-pagination');
    if (pagination && this.totalPages > 1) {
      let nextHref = new URL(window.location.href);
      nextHref.searchParams.set('page', this.currentPage + 1);
      let prevHref = new URL(window.location.href);
      prevHref.searchParams.set('page', this.currentPage - 1);
      pagination.innerHTML = `
        <a href="${prevHref}" class="op-pagination-button prev btn btn--primary" data-page="${this.currentPage - 1}" ${this.currentPage <= 1 ? 'disabled' : ''}>${window.theme.strings.pagination.previous}</a>
        <span class="op-pagination-current">${this.currentPage} / ${this.totalPages}</span>
        <a href="${nextHref}" class="op-pagination-button next btn btn--primary" data-page="${this.currentPage + 1}" ${this.currentPage >= this.totalPages ? 'disabled' : ''}>${window.theme.strings.pagination.next}</a>
      `;
    }
  }

  renderInvoices() {
    let tableData = [];
    // console.log(this.invoices);
    this.invoices.forEach(invoice => {
      let invoiceIdHtml = `<a href="/pages/faktura-detaljer?id=${invoice.invoiceId}">${invoice.invoiceId}</a>`;
      let invoiceType = invoice.type;
      if (invoiceType == 'INVOICE') {
        invoiceType = window.theme.strings.opInvoice.invoice;
      } else if (invoiceType == 'CREDIT_NOTE') {
        invoiceType = window.theme.strings.opInvoice.creditNote
      }
      tableData.push([
        invoiceIdHtml || '',
        window.convertDateToDanishFormat(invoice.dueDate),
        invoice.deliveryTo || '',
        invoice.invoiceVia || '',
        invoiceType || '',
        invoice.totalPriceExVat ? invoice.totalPriceExVat.replace('.', ',') : ''
      ]);
    });
    const table = this.querySelector('#op-invoices-table');
    if (table && tableData.length && typeof table.setRows === 'function') {
      table.classList.remove('hidden');
      table.setRows(tableData);
    }
  }
}

customElements.define('op-invoice-list', OpInvoiceList);